import React from 'react';
import { MaterialSymbol } from '@material-symbols/font-400';
import MaterialIcon from '../material-icon';
import { ButtonContainer, SpinnerContainer } from './cta-button.styles';

interface ButtonProps {
    className?: string | undefined;
    variant: 'primary' | 'secondary' | 'tertiary' | 'ghost';
    size: 'L' | 'M' | 'S' | 'XS';
    label: string;
    disabled?: boolean;
    icon?: MaterialSymbol;
    iconStyle?: 'outlined' | 'round' | 'sharp' | 'two-tone' | 'filled';
    color?: string;
    fullWidth?: boolean;
    minWidth?: number;
    loading?: boolean;
    noPadding?: boolean;
    /**
     * Defaults to "button". Set "submit" inside a real <form> so the browser
     * treats the click as a form submission, which is what lets a password
     * manager notice a credential change.
     */
    type?: "button" | "submit";
    onClick?: () => void;
}

const CTAButton: React.FC<ButtonProps> = ({
    className,
    variant,
    size,
    label,
    disabled,
    icon,
    iconStyle = 'outlined',
    color,
    fullWidth = false,
    minWidth,
    loading = false,
    noPadding = false,
    type = "button",
    onClick,
}) => {
    return (
        <ButtonContainer
            type={type}
            className={className}
            variant={variant}
            color={color}
            size={size}
            fullWidth={fullWidth}
            minWidth={minWidth}
            disabled={disabled || loading}
            loading={loading}
            noPadding={noPadding}
            onClick={onClick && !disabled ? (e) => {
                e.stopPropagation();
                onClick();
            } : undefined}
        >
            {/* Render loading spinner if loading, else render label and icon */}
            {loading ? (
                <SpinnerContainer
                    className="spinner-border spinner-border-sm text-light"
                    role="status"
                />
            ) : (
                <>
                    {variant !== 'ghost' && icon && (
                        <MaterialIcon
                            icon={icon}
                            style={iconStyle}
                            size={24}
                            color={color}
                            marginRight="8px"
                        />
                    )}
                    {label}
                    {variant === 'ghost' && icon && (
                        <MaterialIcon
                            icon={icon}
                            style={iconStyle}
                            size={size === "L" ? 20 : 16}
                            color={color}
                            marginLeft={size === "L" ? "4px" : "2px"}
                        />
                    )}
                </>
            )}
        </ButtonContainer>
    );
};

export default CTAButton;
